import React from "react";
import { FaBolt, FaChartLine, FaCode, FaHandsHelping } from "react-icons/fa";

function BenefitsOFSolana() {
  return (
    <>
      <div
        className="feature-style-one-area default-padding bg-gray blurry-shape-right-bottom"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/3.png)",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="site-heading">
                <h4 className="sub-title">Our Features</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Benefits of Solana Development with Xeer Technology?
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="fade-up-anim">
            <div className="row">
              <div className="col-xl-12">
                <div className="feature-style-one-items ">
                  <div className="feature-style-one ">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaBolt size={40} />
                      </div>
                      <h4>High-Speed, Low-Cost Transactions</h4>
                      <p>
                        Solana's PoH mechanism supports high-speed transactions
                        at low fees, ideal for high-demand applications.
                      </p>
                    </div>
                  </div>

                  <div className="feature-style-one ">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaChartLine size={40} />
                      </div>
                      <h4>Scalability for Growth</h4>
                      <p>
                        Solana's architecture is built to scale, enabling
                        projects to handle thousands of transactions per second
                        without compromising security.
                      </p>
                    </div>
                  </div>

                  <div className="feature-style-one ">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaCode size={40} />
                      </div>
                      <h4>Developer-Friendly</h4>
                      <p>
                        Our Solana developers bring expertise in Rust and the
                        Solana SDK, enabling rapid development and deployment.
                      </p>
                    </div>
                  </div>
                  <div className="feature-style-one ">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaHandsHelping size={40} />
                      </div>
                      <h4>Comprehensive Support</h4>
                      <p>
                        From project conception to deployment and beyond, Xeer
                        provides full-cycle support for every phase of Solana
                        development.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BenefitsOFSolana;
